<div [attr.id]="gmapElementId" class="map-container"></div>
